import React, { useState, useEffect, useContext } from "react";
import { StoreContext } from "components/StoreContext";
import DynamicTextPage from "components/DynamicTextPage";

const PurchaseTerms = () => {
  const [loading, setLoading] = useState(true);
  const [purchaseTerms, setPurchaseTerms] = useState(null);
  const { store, StoreAPI } = useContext(StoreContext);

  useEffect(() => {
    if (store.loaded) {
      setLoading(true);
      StoreAPI.get(`Marketing/purchaseterms`)
        .then(response => {
          setPurchaseTerms(response.data.pucrhaseTerms);
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [store.loaded]);

  return (
    <>
      <DynamicTextPage
        loading={loading}
        title="Purchase Terms"
        state={purchaseTerms}
      />
    </>
  );
};

export default PurchaseTerms;
